import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Dialog } from "primereact/dialog";
import Langs, { Localize } from "../../app/lang/langs";
import { InputField } from "../../components/inputs/InputField";
import { contractsLocationsOptions, editCollabContract, getCollabContract, optionsSortie, typeOfContractOptions } from "../../components/collabs/collabsSlice";
import { Col, Row } from "react-bootstrap";
import { DynamicButton } from "../../components/buttons/DynamicButton";
import { showErrorToast } from "../../app/utils/helpers";
import moment from "moment";
import { setIsLoading } from "../common/commonSlice";

export default function ViewContractModal(props) {

    const dispatch = useDispatch()

    const isMobile = useSelector((state) => state.settings.isMobile)
    const companies = useSelector((state) => state.collabs.companies)
    const subcontractors = useSelector((state) => state.clients.subcontractors)
    const [updatedItem, setUpdatedItem] = useState(props.selectedContract)
    const [visibleFields, setVisibleFields] = useState([])
    const allCollabs = useSelector((state) => state.collabs.allCollabsList)

    useEffect(() => {
        if (props.selectedContract) {

            setUpdatedItem(props.selectedContract)
            let isInterne = props.selectedContract["type_collab"] == "interne"

            setVisibleFields([
                { key: "type_collab", type: "string", disabled: true },
                { key: "id_company", type: "dropdown", options: companies, disabled: true },
                { key: "type_contrat", type: "dropdown", options: typeOfContractOptions, disabled: true },
                { key: "id_subcontractor", type: "dropdown", options: subcontractors, forType: "externe" },
                { key: "statut_emploi", type: "string", forType: "interne", disabled: true },
                { key: "etablissement", type: "dropdown", options: contractsLocationsOptions, disabled: isInterne },
                { key: "entree_date", type: "date", disabled: isInterne },
                { key: "sortie_date", type: "date" },
                { key: "motif_sortie", type: "dropdown", options: optionsSortie },
                { key: "date_debut_cp", type: "date", forType: "externe" },
                { key: "date_fin_cp", type: "date", forType: "externe" },
                { key: "code_csp", type: "string", forType: "interne", disabled: true },
                { key: "coefficient", type: "string", forType: "interne", disabled: true },
                { key: "position", type: "string", forType: "interne", disabled: true },
                { key: "periode_essai_1", type: "date", forType: "interne", disabled: true },
                { key: "periode_essai_2", type: "date", forType: "interne", disabled: true },
                { key: "tjm_achat", type: "string", forType: "externe" },
                { key: "tjm_vente", type: "string", forType: "externe" },
                { key: "ticket_restaurant", type: "string", forType: "interne", disabled: true },
                { key: "did_not_start", type: "string", disabled: true },
                { key: "dedit_formation", type: "string", forType: "interne" },
                { key: "school", type: "string", forType: "interne" },
                { key: "school_contact", type: "string", forType: "interne" },
                { key: "diploma", type: "string", forType: "interne" },
                { key: "training_cost", type: "string", forType: "interne" },
                { key: "remaining_cost", type: "string", forType: "interne" },
                { key: "id_tutor", type: "dropdown", options: allCollabs, forType: "interne" },
                { key: "comments", type: "text" }
            ])
        }
    }, [props.selectedContract])

    const handleFieldChange = (value, field) => {
        setUpdatedItem(prev => ({
            ...prev,
            [field.key]: value
        }))
    }

    function getFormattedDate(date) {
        return date ? moment(date).format("YYYY-MM-DD HH:mm:ss") : null
    }

    const handleSave = async () => {
        dispatch(setIsLoading(true))
        if (updatedItem && updatedItem.id_collab) {
            const responseContract = await dispatch(editCollabContract({
                collab_contract: {
                    ...updatedItem,
                    sortie_date: getFormattedDate(updatedItem.sortie_date),
                    entree_date: getFormattedDate(updatedItem.entree_date),
                    date_debut_cp: getFormattedDate(updatedItem.date_debut_cp),
                    date_fin_cp: getFormattedDate(updatedItem.date_fin_cp),
                    new_date_debut_cp: getFormattedDate(updatedItem.new_date_debut_cp)
                }
            })).unwrap()

            dispatch(getCollabContract({ id_collab: updatedItem.id_collab }))

            if (responseContract.responseData?.error == "conflict") {
                showErrorToast("CONTRACT_CONFLICT_ERROR")
            }
            const contractError = responseContract && responseContract["responseError"]
            if (contractError) {
                showErrorToast()
            }
        }
        dispatch(setIsLoading(false))
        if (props.onHide) props.onHide()
    }

    const renderFooter = () => {
        if (props.selectedContract && JSON.stringify(updatedItem) != JSON.stringify(props.selectedContract)) {
            return <Row className="d-flex justify-content-center">
                <Col md={6}>
                    <DynamicButton
                        title={Localize("SAVE")}
                        active={true}
                        onClick={handleSave}
                        color="green"
                    /></Col>
            </Row>
        }
    }

    return (
        <Dialog
            visible={props.selectedContract}
            style={{ width: isMobile === 2 ? "90%" : "50%" }}
            onHide={() => {
                props.onHide()
            }}
            header={<Langs str="VIEW_CONTRACT" />}
            footer={renderFooter}
            draggable={false}
            dismissableMask={false}
        >
            {visibleFields.map(field => {
                if (!field.forType || (updatedItem && field.forType == updatedItem["type_collab"]))
                    return <InputField field={field}
                        onChange={(e) => handleFieldChange(e, field)}
                        value={updatedItem && updatedItem[field.key]} />
            })
            }
        </Dialog>
    )
}